import React from 'react';

import { NEWSLETTER_SUBSCRIBE_URL } from 'core/constants';
import { useBreakpoints } from 'core/hooks';
import { newsletterSubscribe as strings } from 'core/i18n';

export default function NewsletterSubscribeBanner() {
  const { isLarge } = useBreakpoints(['large']);

  const linkText = isLarge
    ? strings.subscribeActionShort
    : strings.subscribeActionLong;

  return (
    <section className="newsletter-subscribe-banner rw-col--sm-6 rw-col--md-6 rw-col--offset-md-1 rw-col--lg-8 rw-col--offset-lg-2">
      <div className="newsletter-subscribe-banner__icon" />
      <span className="newsletter-subscribe-banner__description">
        {strings.subscribeDescription}
      </span>
      <a
        href={NEWSLETTER_SUBSCRIBE_URL}
        className="newsletter-subscribe-banner__link rw-button rw-button--secondary-white"
      >
        {linkText}
      </a>
    </section>
  );
}
